import React from 'react';
import {FormGroup, TextArea} from '@blueprintjs/core';

interface TextareaProps {
  label: string;
  value: string;
  disabled?: boolean;
  placeholder?: string;
  onChange: (value: any) => void;
}

export const Textarea = ({
  label,
  value,
  disabled = false,
  placeholder = '',
  onChange,
}: TextareaProps) => {
  return (
    <FormGroup
      label={label}
      inline={true}
      className="textarea-input"
    >
      <TextArea
        value={value}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
        fill={true}
      />
    </FormGroup>
  )
};

export default Textarea;
